import React, { useState } from "react";

const Pagination = ({ totalItems = 738, itemsPerPage = 12 }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [currentPage, setCurrentPage] = useState(1);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        pages.push(1, 2, 3, "...", totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1, "...", totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(
          1,
          "...",
          currentPage - 1,
          currentPage,
          currentPage + 1,
          "...",
          totalPages
        );
      }
    }
    return pages;
  };

  return (
    <div className="flex items-center justify-between py-4 pt-12 w-full">
      {/* Left: Showing text */}
      <p className="text-[#0F172A] ml-6 font-inter font-semibold text-xl leading-[150%]">
        Showing {(currentPage - 1) * itemsPerPage + 1}-
        {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}
      </p>

      {/* Right: Pagination */}
      <div className="flex items-center space-x-4 mr-10">
        <button
          className="px-3 py-2 bg-white rounded-md shadow hover:bg-gray-300 disabled:opacity-50 text-2xl"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          &lt;
        </button>

        {renderPageNumbers().map((page) => (
          <button
            key={page} 
            className={`px-4 py-3 rounded-md shadow text-xl font-semibold ${
              page === currentPage
                ? "bg-blue-900 text-white"
                : "bg-white hover:bg-gray-300"
            }`}
            onClick={() => typeof page === "number" && goToPage(page)}
            disabled={page === "..."}
          >
            {page}
          </button>
        ))}

        <button
          className="px-3 py-2 bg-white rounded-md shadow hover:bg-gray-300 disabled:opacity-50 text-2xl"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default Pagination;
